'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FullStorySDK = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _visitorId = require('helpers/visitorId');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FS_SDK_JS = 'window._fs_debug = false;\nwindow._fs_host = \'www.fullstory.com\';\nwindow._fs_org = \'174QC\';\n(function(m,n,e,t,l,o,g,y){\n  g=m[e]=function(a,b){g.q?g.q.push([a,b]):g._api(a,b);};g.q=[];\n  o=n.createElement(t);o.async=1;o.src=\'https://\'+_fs_host+\'/s/fs.js\';\n  y=n.getElementsByTagName(t)[0];y.parentNode.insertBefore(o,y);\n  g.identify=function(i,v){g(l,{uid:i});if(v)g(l,v)};g.setUserVars=function(v){FS(l,v)};\n  g.identifyAccount=function(i,v){o=\'account\';v=v||{};v.acctId=i;FS(o,v)};\n  g.clearUserCookie=function(d,i){d=n.domain;while(1){n.cookie=\'fs_uid=;domain=\'+d+\n  \';path=/;expires=\'+new Date(0);i=d.indexOf(\'.\');if(i<0)break;d=d.slice(i+1)}}\n})(window,document,\'FS\',\'script\',\'user\');';

var DEFAULT_SAMPLE_SIZE = 0.1;
var ELEVATED_SAMPLE_SIZE = 0.33;
var ELEVATED_PATHS = ['live$', 'live/', 'videos$', 'videos/', 'search$', 'search/'];
var ELEVATED_PATH_REGEX = new RegExp('^/(?:' + ELEVATED_PATHS.join('|') + ')');

var FullStorySDK = exports.FullStorySDK = function (_React$Component) {
  (0, _inherits3.default)(FullStorySDK, _React$Component);

  function FullStorySDK() {
    (0, _classCallCheck3.default)(this, FullStorySDK);
    return (0, _possibleConstructorReturn3.default)(this, (FullStorySDK.__proto__ || (0, _getPrototypeOf2.default)(FullStorySDK)).apply(this, arguments));
  }

  (0, _createClass3.default)(FullStorySDK, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      if (nextProps.currentUser && !this.props.currentUser && this.fs()) {
        this.fs().identify(String(nextProps.currentUser.id), {
          email: nextProps.currentUser.email
        });
      }
      return false;
    }
  }, {
    key: 'getSampleSizeForPath',
    value: function getSampleSizeForPath(path) {
      return ELEVATED_PATH_REGEX.test(path) ? ELEVATED_SAMPLE_SIZE : DEFAULT_SAMPLE_SIZE;
    }

    /* istanbul ignore next */

  }, {
    key: 'fs',
    value: function fs() {
      return window.fs;
    }
  }, {
    key: 'useFullStory',
    value: function useFullStory() {
      var _props = this.props,
          currentPath = _props.currentPath,
          visitorId = _props.visitorId;

      var sampleSize = this.getSampleSizeForPath(currentPath);
      return (0, _visitorId.visitorIdInsidePercentile)(visitorId, 0.0, sampleSize) && (!__LOCAL_DEV__ || __TEST__);
    }
  }, {
    key: 'render',
    value: function render() {
      var currentUser = this.props.currentUser;


      if (!this.useFullStory()) {
        return false;
      }

      var userSetJs = void 0;

      if (currentUser) {
        userSetJs = 'FS.identify("' + currentUser.id + '", {\n        email: ' + (0, _stringify2.default)(currentUser.email) + '\n      });';
      }

      return _react2.default.createElement('script', {
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: { __html: (FS_SDK_JS + userSetJs).replace(/\n/g, '') }
      });
    }
  }]);
  return FullStorySDK;
}(_react2.default.Component);

FullStorySDK.propTypes = {
  currentUser: _propTypes2.default.object,
  currentPath: _propTypes2.default.string.isRequired,
  visitorId: _propTypes2.default.string
};